<template>
  <div class="open_door">
    <uni-popup ref="openTheDoor" type="bottom">
      <uni-card title="病历" :is-full="true" note="">
        <div class="wolf">
          <div class="wolf_title">请您选择病历模版</div>
          <div class="live_or_die">
            <div
              v-for="(item, i) in recordData"
              :key="i"
              class="live_box"
              @click="selectRecord(item)"
            >
              <img :src="require(`@funcPuzzle/mini_doctor/${item.selectImg}.png`)" class="search" />
              <div class="box_text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <template v-slot:footer></template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValueText, getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import { getBusinessConfig } from '@/views/funcPuzzle/utils/index.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['doctor', 'hospitalInfo'])
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formDetail: {
      type: [Object, String],
      default: ''
    },
    openList: {
      type: [Object, String, Array],
      default: ''
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getRecordList()
        } else {
          // this.close()
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      timeBox: [],
      recordList: [
        {
          selectImg: 'chineseMedicine',
          text: '中医',
          code: '2'
        },
        {
          selectImg: 'westernMedicine',
          text: '西医',
          code: '1'
        }
      ],
      recordData: []
    }
  },
  methods: {
    getKeyValueText,
    getKeyValue,
    async getRecordList() {
      const { code, DoctorServicePackageList } = await getBusinessConfig(
        'enabled_symptom_template_type',
        this.hospitalInfo.hospitalID
      )
      // 没有返回时 直接return
      if (
        String(code) !== '0' ||
        !DoctorServicePackageList ||
        DoctorServicePackageList.length === 0
      ) {
        return
      }
      // 从配置中拿到的病历模板数据
      const list = JSON.parse(DoctorServicePackageList[0].value).EnabledSymptomTemplateType

      // 过滤拿到的配置和当前的recordList中 code和symptomTemplateType 相同的数据 放到recordData中
      this.recordData = this.recordList.filter(item =>
        list.some(val => val.symptomTemplateType === item.code)
      )

      // 开启选择病历的弹窗
      this.open()
    },
    selectRecord(item) {
      // 如果没有主诉
      if (!this.formDetail) {
        this.$emit('childByValue', {
          medicine: item.code === '2' ? 0 : 1,
          empty: false
        })
        this.close()
        return false
      }
      // code 2 中医 code 1 西医
      let symptomType //正在编辑的病历的病历类型 1西医 2中医
      if (this.formDetail) {
        symptomType = this.openList.findIndex(
          item => item.symptomType === '2' || item.symptomType === '4'
        )
      } else {
        symptomType = false
      }
      // console.log('symptomType', symptomType)
      // console.log('item.code', item.code)
      // console.log(this.openList, 'openList')
      // console.log('symptomType2', symptomType)
      // console.log(this.openList, 'openList')
      // 如果当前选中的类型是中医 则走第一个方法 否则走第二个 方法里面是沿用的其他人写的方法没有动
      item.code === '2'
        ? this.switchTemplate(symptomType == -1, item)
        : this.switchTemplate(symptomType != -1 && symptomType !== false, item)
    },
    switchTemplate(condition, item) {
      if (condition) {
        uni.showModal({
          title: '提示',
          content: '模板切换后，编辑数据将不会被保存，您确定切换模板？',
          success: res => {
            if (res.confirm) {
              // 如果是中医 medicine为0 否则为1
              this.$emit('childByValue', {
                medicine: item.code === '2' ? 0 : 1,
                empty: true
              })
              this.close()
            } else if (res.cancel) {
              return false
            }
          }
        })
      } else {
        this.$emit('childByValue', {
          medicine: item.code === '2' ? 0 : 1,
          empty: false
        })

        this.close()
      }
    },
    close() {
      this.$emit('update:visible', false)
      if (!this.$refs.openTheDoor) {
        return false
      }
      this.$refs.openTheDoor.close()
    },
    open() {
      this.$refs.openTheDoor.open()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.open_door {
  width: 16rem;

  .wolf {
    width: 14.634667rem;
    height: 9.728rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .wolf_title {
      color: #222;
      font-size: 0.64rem;
    }

    .live_or_die {
      margin-top: 2.176rem;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .live_box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .box_text {
          margin-top: 0.426667rem;
          color: #222;
          font-size: 0.64rem;
        }

        .search {
          width: 2.133333rem;
          height: 2.133333rem;
        }
      }
    }
  }
}
</style>
